import { BaseEnum } from "./baseEnum";

const listWorkforceplanStatusEnum: Array<WorkforceplanEmployeeStatusType> = [];

export class WorkforceplanEmployeeStatusType extends BaseEnum {
	static PENDING = new WorkforceplanEmployeeStatusType(0, 'PENDING', 'Pendente', 'light-secondary');
	static ACTIVE = new WorkforceplanEmployeeStatusType(1, 'ACTIVE', 'Ativo', 'light-success');
	static EXPERIENCE = new WorkforceplanEmployeeStatusType(2, 'EXPERIENCE', 'Experiência', 'light-info');
	static WORK_LEAVE = new WorkforceplanEmployeeStatusType(3, 'WORK_LEAVE', 'Afastado', 'light-warning');
	static RESIGNATION = new WorkforceplanEmployeeStatusType(4, 'RESIGNATION', 'Em desligamento', 'light-danger');
	static TRAINING = new WorkforceplanEmployeeStatusType(5, 'TRAINING', 'Em treinamento', 'light-primary');
	static PENDING_HIRING = new WorkforceplanEmployeeStatusType(6, 'PENDING_HIRING', 'Em contratação', 'light-purple');
	static PENDING_JOBTITLE_CHANGE = new WorkforceplanEmployeeStatusType(7, 'PENDING_JOBTITLE_CHANGE', 'Em mudança de Função', 'light-indigo');
	static PENDING_PROMOTION = new WorkforceplanEmployeeStatusType(8, 'PENDING_PROMOTION', 'Em Promoção', 'light-purple');
	static PENDING_APTITUDE_TRAINING = new WorkforceplanEmployeeStatusType(9, 'PENDING_APTITUDE_TRAINING', 'Em treinamento de aptidão', 'light-primary');
	static PENDING_HIRING_SUBSTITUTION = new WorkforceplanEmployeeStatusType(10, 'PENDING_HIRING_SUBSTITUTION', 'Em substituição', 'light-purple');

	constructor(public id: number, public value: string, public label: string, public className: string) {
		super(id, value, label, className);

		listWorkforceplanStatusEnum.push(this);
	}

	public static buildListEnum(): Array<BaseEnum> {
		return listWorkforceplanStatusEnum;
	}
}
